<template>
    <div>
        <h4 class="title is-size-4">{{ pageTitle }}</h4>

        <button class="button mb-4" v-if="this.area=='in_print' || this.area=='in_artwork' || this.area=='in_cutting'" :class="{'is-success' : show_dublin_makeup_only == true}" :disabled="loading==true" @click="updateDublinMakeup()">Show Dublin Makeup Orders ONLY</button>

        <div class="notification is-info" v-if="loading === true">
                    Loading orders ...
            </div>
        <div class="notification is-warning" v-if="loading == false && filteredOrders.length == 0">
            There are no orders to show

            <table  :id="area + '_export'" style="display:none">
                <tbody>
                    <tr>
                        <td>There are no orders to show</td>
                    </tr>
                </tbody>
            </table>
        </div>
        

        <table class="table is-hoverable is-fullwidth is-size-7" :id="area" v-if="loading == false && filteredOrders.length > 0">
            <thead>
            <tr>
            <th>PO Number</th>
            <th>Qty</th>
            <th>Garment</th>
            <th>Rep Name</th>
            <th width="80">Ordered</th>
            <th width="80">Delivery</th>
            <th>Makeup</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
                <td >{{order.ponumber}}</td>
                <td>{{ order.total_qty }}</td>
                <td>{{order.garmentname}}</td>
            <td>{{order.firstname}} {{ order.surname }}</td>
            <td>{{order.orderdate}}</td>
            <td>{{order.deliverydate}}</td>
            <td>{{ order.makeup_location_name}}</td>
                </tr>
            </tbody>
            
        </table>

        <table  :id="area + '_export'" v-if="loading == false && filteredOrders.length > 0" style="display:none">
            <thead>
            <tr>
            <th>PO Number</th>
            <th>Qty</th>
            <th>Garment</th>
            <th>Rep Name</th>
            <th >Ordered</th>
            <th >Delivery</th>
            <th>Makeup</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
                <td >{{order.ponumber}}</td>
                <td>{{ order.total_qty }}</td>
                <td>{{order.garmentname}}</td>
            <td>{{order.firstname}} {{ order.surname }}</td>
            <td>{{order.orderdate_raw}}</td>
            <td>{{order.deliverydate_raw}}</td>
            <td>{{ order.makeup_location_name}}</td>
                </tr>
            </tbody>
            
        </table>
    </div>
</template>

<script>
import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
    name: 'ProductionOrderList',
    props: ['area', 'search', 'show_dublin_makeup_only'],
    components: {
    
  },
  methods: {
    updateDublinMakeup() {
        if(this.show_dublin_makeup_only == true)
        {
            this.$emit('update_dublin_makeup', false)
        }
        else{
            this.$emit('update_dublin_makeup', true)
        }
    },
    async getOrders() {
        this.loading=true
        this.orders = []

        if(this.area == "wip_derry")
        {
            OrderService.getMakeupOrders(this.accessToken, 4, this.limit, this.order_by, this.end_date)
            .then(
            (orders => {
                this.$set(this, "orders", orders);
                this.loading=false
                this.$emit('update_totals', "wip_derry", this.orders.length, this.garments_total)
            }).bind(this)
            );
        }
        else if(this.area == "wip_dublin")
        {
            OrderService.getMakeupOrders(this.accessToken, 3, this.limit, this.order_by, this.end_date)
            .then(
            (orders => {
                this.$set(this, "orders", orders);
                this.loading=false
                this.$emit('update_totals', "wip_dublin", this.orders.length, this.garments_total)
            }).bind(this)
            );
        }
        else if(this.area == "wip_strabane")
        {
            OrderService.getMakeupOrders(this.accessToken, 1, this.limit, this.order_by, this.end_date)
            .then(
            (orders => {
                this.$set(this, "orders", orders);
                this.loading=false
                this.$emit('update_totals', "wip_strabane", this.orders.length, this.garments_total)
            }).bind(this)
            );
        }
        else if(this.area == "in_artwork")
        {
            OrderService.getDigitalPrintScheduler(this.accessToken, "", this.order_by, this.start_date, this.end_date, "artwork", this.print_location_id, this.range_id, this.artwork_print_location_id)
            .then(
            (orders => {
                this.$set(this, "orders", orders);
                this.loading=false
                this.$emit('update_totals', "in_artwork", this.orders.length, this.garments_total)
            }).bind(this)
            );
        }
        else if(this.area == "in_print")
        {
            OrderService.getAllPrintingOrders(this.accessToken, this.print_location_id, this.limit, this.order_by, this.start_date)
            .then(
            (orders => {
                this.$set(this, "orders", orders);
                this.loading=false
                this.$emit('update_totals', "in_print", this.orders.length, this.garments_total)
            }).bind(this)
            );
        }
        else if(this.area == "in_cutting")
        {
            OrderService.getCuttingOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.start_date)
            .then(
            (orders => {
                this.$set(this, "orders", orders);
                this.loading=false
                this.$emit('update_totals', "in_cutting", this.orders.length, this.garments_total)
            }).bind(this)
            );
        }
        else if(this.area == "orders_rec"){
            OrderService.getIncomingArtworkOrders(this.accessToken, "", this.order_by, 0)
            .then(
            (orders => {
                this.$set(this, "orders", orders);
                this.loading=false
                this.$emit('update_totals', "orders_rec", this.orders.length, this.garments_total)
            }).bind(this)
            );
        }
        
      },
  },
  mixins: [OrderMixin],
  data() {
    return {
        orders: [],
        accessToken: '',
        loading: true,
        order_by: 'deliverydate ASC',
        start_date: '',
        end_date: '',
        makeup_location_id: '',
        include_blanks: '',
        location: '',
        limit: '',
        print_location_id: 1, // Hardcode to Strabane
         range_id: '',
         artwork_print_location_id: '',
         scheduler_type: ''
    }
  },
  computed : {
        pageTitle: function() {
            let pageTitle = "Unknown"

            if(this.area == "orders_rec")
            {
                pageTitle = "Orders Received"
            }
            else if(this.area == "in_artwork")
            {
                pageTitle = "In Artwork"
            }
            else if(this.area == "in_print")
            {
                pageTitle = "In Print"
            }
            else if(this.area == "in_cutting")
            {
                pageTitle = "In Cutting"
            }
            else if(this.area == "wip_derry")
            {
                pageTitle = "Work In Progress - Derry"
            }
            else if(this.area == "wip_dublin")
            {
                pageTitle = "Work In Progress - Dublin"
            }
            else if(this.area == "wip_strabane")
            {
                pageTitle = "Work In Progress - Strabane"
            }
            

            return pageTitle
        },
        filteredOrders: function () {
       
             let filteredOrders =  this.orders

            if(this.search != '' && this.search != null)
            {
            //filteredOrders = filteredOrders.filter(row => row.range_name.toLowerCase().includes(this.search.toLowerCase()) || row.designname.toLowerCase().includes(this.search.toLowerCase()) || row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
            }

            if(this.area=='in_print' || this.area=='in_artwork' || this.area=='in_cutting')
            {
                if(this.show_dublin_makeup_only == true)
                {
                filteredOrders = filteredOrders.filter(row => row.makeup_location_id == 3) 
                }
            }
            

            return filteredOrders
        
        },
        garments_total() {
            return this.filteredOrders.reduce((sum, row) => sum + row.total_qty, 0);
        },
  },
  created() {
    this.getAccessToken()
        .then(() => { 
           this.getOrders();
        });
  },
}
</script>